import React from 'react';

import cx from 'classnames';

import { ErrorContent } from './ErrorContent';
import styleError from './ErrorPage.module.css';
import s from '../Authorization/Authorization.module.css';
import { ButtonContainer } from '../Authorization/Button/Button';

export const ErrorPage = () => {
    const errorCode = window.error;

    return (
        <div className={s.content}>
            <div className={cx(s.mainImage, styleError.errorImage)} />
            <div className={s.formWrapper}>
                <div className={s.loginBlock}>
                    {errorCode && <ErrorContent errorCode={errorCode} />}
                    <div className={styleError.buttonBlock}>
                        <a href={ENV.APP_HTTP_HOST}>
                            <ButtonContainer
                                textButton={i18next.t(
                                    'ErrorPage.return.ButtonContainer.textButton'
                                )}
                                disable={false}
                                needShowLoader={false}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
